export default "__VITE_ASSET__CJsVgC40__"